import { API_URL } from '../../config/constants';
import { DocumentResponseModel } from '../../store/api-generated';

interface UseDownloadDocumentArgs {
  onError?: (documentId: string) => void;
}

interface DownloadDocumentArgs {
  documentType: 'invoice' | 'contract';
  documentId: string;
  alternateId?: string;
}

/**
 * Helper that returns a function to download a document. We use fetch under the hood instead of Redux because we do not want to cache
 * the files in memory. This is due to the performance strain on lower end devices.
 */
export default function useDownloadDocument({
  onError,
}: UseDownloadDocumentArgs = {}) {
  function downloadDocument({
    documentType,
    documentId,
    alternateId,
  }: DownloadDocumentArgs) {
    const params = new URLSearchParams({
      documentType: documentType === 'invoice' ? 'factuur' : 'contract',
      documentId,
    });

    if (alternateId) {
      params.set('alternateId', alternateId);
    }

    fetch(`${API_URL}/v1/proxy/mijn-omgeving/document?${params.toString()}`, {
      method: 'get',
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data: DocumentResponseModel) => {
        if (data.Stream) {
          fetch(`data:application/pdf;base64,${data.Stream}`).then(async (res) => {
            const fileUrl = URL.createObjectURL(await res.blob());
            const downloadLink = document.createElement('a');
            downloadLink.href = fileUrl;
            downloadLink.download = data.Filename || `${documentId}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            URL.revokeObjectURL(fileUrl);
            downloadLink.remove();
          });
        }
      })
      .catch((error) => {
        if (onError) {
          onError(documentId);
        }

        console.error(error);
      });
  }

  return {
    downloadDocument,
  } as const;
}
